module.exports = {"header":"Online Chat","notSupportedBrowser":"Ми не підтримуємо браузер Internet Explorer","input_placeholder":"Повідомлення...","header_title_first":"Онлайн","header_title_second":"Чат","viewed":"Переглянуто","connection_problem":"Проблема підключення","refresh_page":"Оновіть сторінку"}


//////////////////
// WEBPACK FOOTER
// ./src/components/locale/ua.json
// module id = 245
// module chunks = 0